import React, { useState, useEffect } from 'react';
import { Send, Users, Settings, MessageSquare, AlertCircle, CheckCircle, Clock, Target } from 'lucide-react';

// ДОБАВЛЯЕМ КОНСТАНТУ API_BASE_URL как в других сервисах
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const BroadcastAdmin = () => {
    const [message, setMessage] = useState('');
    const [targetUsers, setTargetUsers] = useState('all');
    const [parseMode, setParseMode] = useState('HTML');
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [stats, setStats] = useState(null);

    // Предустановленные шаблоны сообщений
    const templates = [
        {
            name: 'Системное обновление',
            content: `🔄 <b>Системное обновление</b>

Уважаемые партнеры!

✨ Мы внедрили новые функции для улучшения вашего опыта:
• Обновленный дашборд
• Улучшенная система уведомлений
• Новые инструменты аналитики

🚀 Продолжайте развивать свою команду и увеличивать доходы!

С уважением, команда ЛАЙТ`
        },
        {
            name: 'Акция для партнеров',
            content: `🎉 <b>Специальная акция!</b>

📅 Только до конца месяца:

💰 <b>Удвоенные бонусы</b> за каждого нового партнера!
🏆 Специальные призы для топ-партнеров
🎯 Дополнительные возможности заработка

⏰ Не упустите шанс увеличить свой доход!
👥 Приглашайте новых партнеров прямо сейчас!

#ЛайтАкция #УдвоенныеБонусы`
        },
        {
            name: 'Поздравление с результатами',
            content: `🏆 <b>Поздравляем с отличными результатами!</b>

Дорогие партнеры!

📈 В этом месяце вы показали выдающиеся результаты:
• Рост команды на 150%
• Увеличение активности на 200%
• Новые рекорды по выплатам

💎 Вы - основа нашего успеха!
🚀 Продолжайте в том же духе!

Спасибо за вашу активность! 🙏`
        }
    ];

    const targetOptions = [
        { value: 'all', label: 'Все пользователи', icon: Users },
        { value: 'active', label: 'Активные пользователи', icon: CheckCircle },
        { value: 'verified', label: 'Верифицированные', icon: Settings },
    ];

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {
        try {
            // ИСПРАВЛЕНО: используем правильный URL с API_BASE_URL
            const response = await fetch(`${API_BASE_URL}/telegram/stats`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                }
            });
            const data = await response.json();
            if (data.success) {
                setStats(data.data);
            }
        } catch (error) {
            console.error('Error loading stats:', error);
        }
    };

    const handleSendBroadcast = async () => {
        if (!message.trim()) {
            alert('Введите сообщение для рассылки');
            return;
        }

        setIsLoading(true);
        setResult(null);

        try {
            // ИСПРАВЛЕНО: используем правильный URL с API_BASE_URL
            const response = await fetch(`${API_BASE_URL}/telegram/broadcast`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: message,
                    target_users: targetUsers,
                    options: {
                        parse_mode: parseMode
                    }
                })
            });

            // ДОБАВЛЯЕМ ОТЛАДКУ
            console.log('Response status:', response.status);

            const responseText = await response.text();
            console.log('Response text:', responseText);

            // Проверяем, что ответ в JSON формате
            let data;
            if (responseText.startsWith('{') || responseText.startsWith('[')) {
                data = JSON.parse(responseText);
            } else {
                setResult({
                    success: false,
                    message: `Ошибка сервера (${response.status}): ${responseText.substring(0, 200)}`
                });
                return;
            }

            setResult(data);

            if (data.success) {
                // Обновляем статистику после отправки
                loadStats();
                // Очищаем сообщение после успешной отправки
                setMessage('');
            }

        } catch (error) {
            console.error('Network error:', error);
            setResult({
                success: false,
                message: 'Ошибка сети: ' + error.message
            });
        } finally {
            setIsLoading(false);
        }
    };

    const applyTemplate = (template) => {
        setMessage(template.content);
    };

    const getTargetIcon = (value) => {
        const option = targetOptions.find(opt => opt.value === value);
        return option ? option.icon : Users;
    };

    const getTargetLabel = (value) => {
        const option = targetOptions.find(opt => opt.value === value);
        return option ? option.label : 'Все пользователи';
    };

    return (
        <div className="max-w-4xl mx-auto p-6 space-y-6">
            {/* Заголовок */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center">
                    <MessageSquare className="text-blue-500 mr-3" size={28} />
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">Telegram рассылка</h1>
                        <p className="text-gray-600">Отправка уведомлений всем подключенным пользователям</p>
                        <p className="text-xs text-gray-400 mt-1">API: {API_BASE_URL}</p>
                    </div>
                </div>
            </div>

            {/* Статистика */}
            {stats && (
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">Подключено</p>
                                <p className="text-2xl font-bold text-green-600">{stats.connected_users || 0}</p>
                            </div>
                            <CheckCircle className="text-green-500" size={24} />
                        </div>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">Активные</p>
                                <p className="text-2xl font-bold text-blue-600">{stats.active_users || 0}</p>
                            </div>
                            <Users className="text-blue-500" size={24} />
                        </div>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">Отправлено сегодня</p>
                                <p className="text-2xl font-bold text-purple-600">{stats.sent_today || 0}</p>
                            </div>
                            <Send className="text-purple-500" size={24} />
                        </div>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">Успешность</p>
                                <p className="text-2xl font-bold text-emerald-600">{stats.success_rate || 0}%</p>
                            </div>
                            <Target className="text-emerald-500" size={24} />
                        </div>
                    </div>
                </div>
            )}

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Шаблоны сообщений */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">📝 Шаблоны</h3>
                    <div className="space-y-3">
                        {templates.map((template, index) => (
                            <button
                                key={index}
                                onClick={() => applyTemplate(template)}
                                className="w-full text-left p-3 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors"
                            >
                                <div className="font-medium text-gray-800 text-sm mb-1">
                                    {template.name}
                                </div>
                                <div className="text-xs text-gray-500 line-clamp-2">
                                    {template.content.split('\n')[0].replace(/<[^>]*>/g, '')}
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Основная форма */}
                <div className="lg:col-span-2 space-y-6">
                    {/* Настройки рассылки */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">⚙️ Настройки рассылки</h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            {/* Целевая аудитория */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Целевая аудитория
                                </label>
                                <select
                                    value={targetUsers}
                                    onChange={(e) => setTargetUsers(e.target.value)}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    {targetOptions.map(option => {
                                        return (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>

                            {/* Формат сообщения */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Формат сообщения
                                </label>
                                <select
                                    value={parseMode}
                                    onChange={(e) => setParseMode(e.target.value)}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="HTML">HTML (рекомендуется)</option>
                                    <option value="Markdown">Markdown</option>
                                    <option value="">Обычный текст</option>
                                </select>
                            </div>
                        </div>

                        {/* Информация о целевой группе */}
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                            <div className="flex items-center">
                                {React.createElement(getTargetIcon(targetUsers), {
                                    size: 16,
                                    className: "text-blue-600 mr-2"
                                })}
                                <span className="text-sm text-blue-800">
                                    Выбрано: {getTargetLabel(targetUsers)}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Текст сообщения */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">✉️ Сообщение</h3>

                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Текст сообщения
                            </label>
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Введите текст сообщения для рассылки..."
                                className="w-full h-48 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none font-mono text-sm"
                            />
                            <div className="mt-2 flex justify-between text-xs text-gray-500">
                                <span>Символов: {message.length}</span>
                                <span>
                                    {parseMode === 'HTML' && '💡 Используйте <b>жирный</b>, <i>курсив</i>, <code>код</code>'}
                                    {parseMode === 'Markdown' && '💡 Используйте **жирный**, *курсив*, `код`'}
                                    {!parseMode && '💡 Обычный текст без форматирования'}
                                </span>
                            </div>
                        </div>

                        {/* Кнопка отправки */}
                        <div className="flex justify-end">
                            <button
                                onClick={handleSendBroadcast}
                                disabled={isLoading || !message.trim()}
                                className="flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors font-medium"
                            >
                                {isLoading ? (
                                    <>
                                        <Clock className="mr-2 animate-spin" size={18} />
                                        Отправка...
                                    </>
                                ) : (
                                    <>
                                        <Send className="mr-2" size={18} />
                                        Отправить рассылку
                                    </>
                                )}
                            </button>
                        </div>
                    </div>

                    {/* Результат */}
                    {result && (
                        <div className={`rounded-xl shadow-sm border p-6 ${
                            result.success
                                ? 'bg-green-50 border-green-200'
                                : 'bg-red-50 border-red-200'
                        }`}>
                            <div className="flex items-start">
                                {result.success ? (
                                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-0.5" size={20} />
                                ) : (
                                    <AlertCircle className="text-red-600 mr-3 flex-shrink-0 mt-0.5" size={20} />
                                )}
                                <div className="flex-1">
                                    <h4 className={`font-semibold mb-2 ${
                                        result.success ? 'text-green-800' : 'text-red-800'
                                    }`}>
                                        {result.success ? 'Рассылка завершена' : 'Ошибка рассылки'}
                                    </h4>
                                    <p className={`text-sm mb-3 ${
                                        result.success ? 'text-green-700' : 'text-red-700'
                                    }`}>
                                        {result.message}
                                    </p>

                                    {result.success && result.data && (
                                        <div className="grid grid-cols-3 gap-4 text-sm">
                                            <div className="text-center p-2 bg-white rounded border">
                                                <div className="font-semibold text-green-600">
                                                    {result.data.sent}
                                                </div>
                                                <div className="text-gray-600">Отправлено</div>
                                            </div>
                                            <div className="text-center p-2 bg-white rounded border">
                                                <div className="font-semibold text-red-600">
                                                    {result.data.failed}
                                                </div>
                                                <div className="text-gray-600">Ошибок</div>
                                            </div>
                                            <div className="text-center p-2 bg-white rounded border">
                                                <div className="font-semibold text-blue-600">
                                                    {result.data.total}
                                                </div>
                                                <div className="text-gray-600">Всего</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Предупреждение */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
                <div className="flex items-start">
                    <AlertCircle className="text-yellow-600 mr-3 flex-shrink-0 mt-0.5" size={20} />
                    <div>
                        <h4 className="font-semibold text-yellow-800 mb-1">Важное предупреждение</h4>
                        <p className="text-yellow-700 text-sm">
                            Массовая рассылка будет отправлена всем пользователям выбранной категории.
                            Убедитесь, что сообщение корректно и соответствует политике платформы.
                            Рекомендуется сначала отправить тестовое сообщение.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BroadcastAdmin;
